import React from "react";
import { COURSE_TYPE_ONLINE } from "../../constants";
import OnlineItem from "./Online";
import ClassroomItem from "./Classroom";

const CoursesItem = (props) => {
  const { course, ...otherProps } = props;
  const basePath = document.location.pathname.replace(
    "activitycentre/activitycentre.aspx",
    "",
  );

  if (course.courseType === COURSE_TYPE_ONLINE) {
    return <OnlineItem course={course} basePath={basePath} {...otherProps} />;
  }

  return <ClassroomItem course={course} basePath={basePath} {...otherProps} />;
};

export default CoursesItem;
